import React from "react";
import { GlobalProvider } from "@d19n/ui-core";
import Layout from "./src/components/Layout";

export const wrapPageElement = ({ element, props }:any) => {
  return <Layout {...props}>{element}</Layout>;
};

export const wrapRootElement = ({ element }:any) => (
  <GlobalProvider>{element}</GlobalProvider>
);
